import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as actions from '../../actions'
import * as selectors from '../../selectors'

const mapStateToProps = (state: ReduxState) => {
  return {
    canceledSubscriptions: selectors.canceledSubscriptionsSelector(state),
    error: selectors.errorSelector(state),
    isLoading: selectors.isLoadingSelector(state, 'isCanceledSubscriptionsLoading'),
  }
}

const mapDispatchToProps = {
  fetchCanceledSubscriptionsReport: actions.fetchCanceledSubscriptionsReport
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector>
